export default __webpack_public_path__ + "static/media/projectImg.f3135a84.jpg";